export * from "ce/utils/AnalyticsUtil";
import { default as CE_AnalyticsUtil } from "ce/utils/AnalyticsUtil";
export default CE_AnalyticsUtil;
